import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a240ba1"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Items Due", -1))
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pay", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Date Created")
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Due On")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Item")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Description")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Amount")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Tax")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Total")
], -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onUpdate:modelValue", "onClick"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Edit")
const _hoisted_17 = {
  key: 1,
  class: "text-center"
}
const _hoisted_18 = { class: "totals" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = { class: "payments" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Payment Amount", -1))
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Convenience Fee", -1))
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 0,
  class: "fee-note"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Total Amount with Convenience Fee", -1))
const _hoisted_32 = {
  key: 1,
  class: "row"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = ["onSubmit"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Payment Method", -1))
const _hoisted_38 = { key: 0 }
const _hoisted_39 = ["value"]
const _hoisted_40 = ["value"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "form-field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First name", -1))
const _hoisted_44 = { class: "form-field" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last name", -1))
const _hoisted_46 = { class: "form-field" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Account number", -1))
const _hoisted_48 = { class: "form-field" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Account number confirmation", -1))
const _hoisted_50 = { class: "form-field" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Routing Number", -1))
const _hoisted_52 = { class: "form-field" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Account Type", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "PERSONAL_CHECKING" }, "Personal Checking", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "PERSONAL_SAVINGS" }, "Personal Savings", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "BUSINESS_CHECKING" }, "Business Checking", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "BUSINESS_SAVINGS" }, "Business Savings", -1))
const _hoisted_58 = [
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { class: "form-field" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Card Type", -1))
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "form-field" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Card Number", -1))
const _hoisted_64 = { class: "form-field" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Expiration Month/Year", -1))
const _hoisted_66 = ["value"]
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "form-field" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "CVV", -1))
const _hoisted_70 = { class: "form-field" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Address", -1))
const _hoisted_72 = { class: "form-field" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City", -1))
const _hoisted_74 = { class: "form-field" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "State/Province", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Select State/Province", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Zip", -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Country", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: null,
  selected: ""
}, "Select Country", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " Save one time payment", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "This will save the payment option as an inactive payment account", -1))
const _hoisted_83 = { key: 2 }
const _hoisted_84 = { class: "form-field" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Check Number", -1))
const _hoisted_86 = { class: "form-field" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Check batch", -1))
const _hoisted_88 = ["value"]
const _hoisted_89 = { class: "form-field" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  type: "submit"
}, "Make Payment", -1))
const _hoisted_92 = ["href"]

import BaseSpinner from "@/components/BaseSpinner.vue";
import OutstandingFeeBanner from "@/components/OutstandingFeeBanner.vue";

import { onMounted, ref, watch } from "vue";
import PaymentResponse from "@/components/PaymentResponse.vue";
import { storeToRefs } from "pinia";
import { useStore } from "../store";
import { paymentAccountInterface, lineItemInterface } from "@/types/customers";
import api from "@virgodev/bazaar/functions/api";
// const router = useRouter();
import moment from "moment";
interface selectedItemInterface {
  id: number;
  amount: string | null;
}
import { useRouter, useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: [Number, String],
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const proceedToPayment = ref(false);
const customer = ref();
const status = ref("loading");
const store = useStore();
const { userData } = storeToRefs(store);
const convenienceFeeSetting =
  userData.value.chosenFacility.require_convenience_fee;
const achNotAccepted = userData.value.chosenFacility.ach_not_accepted;
const subtotal = ref(Number(0.0));
const credit = ref(Number(0.0));
const amountDue = ref(Number(0.0));
const paymentAmount = ref(Number(0));
const checkBatches = ref();
const paymentMethod = ref();
const savePayment = ref(false);
const responseModal = ref(false);
const successfulPayment = ref(false);
const errorPaymentMessage = ref("");
const urlForAuth = ref("");
const convenienceFeeAmount = ref(0.0);
// Previously-missed convenience fee for this customer (from OutstandingFeeBanner).
// The backend folds it into the single charge; shown here so the displayed
// fee/total reflect what the customer is actually charged.
const missedFeeAmount = ref(0);
const selectedItems = ref(Array<selectedItemInterface>());
const paymentAccounts = ref(Array<paymentAccountInterface>());
const facility = ref();
const expirationMonth = ref();
const expirationYear = ref();
const tokenFee = ref();
const formFields = ref({
  transaction: {
    amount: ref(),
    payment_account: {
      account_number: ref(),
      account_number_confirmation: ref(),
      address: ref(),
      card_expires_on: ref(),
      card_number: ref(),
      card_type: ref(),
      city: ref(),
      country: ref(),
      first_name: ref(),
      kind: ref(),
      last_name: ref(),
      routing_number: ref(),
      state: ref(),
      swipe_track_data: ref(),
      zip: ref(),
      verification_value: ref(),
    },
    payment_method: ref(),
    check_batch_id: ref(),
    check_number: ref(),
    line_item_id: ref(),
    message: ref(),

    payment_account_id: ref(),
    prepay_plan_id: ref(),
    rental_id: ref(),
  },
});

const states = [
  "AL",
  "AB",
  "AK",
  "AS",
  "AZ",
  "AR",
  "BC",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FL",
  "GA",
  "GU",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "MB",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "NB",
  "NL",
  "NS",
  "NU",
  "NT",
  "MP",
  "OH",
  "OK",
  "ON",
  "OR",
  "PA",
  "PEI",
  "PR",
  "QC",
  "RI",
  "SC",
  "SD",
  "SK",
  "TN",
  "TX",
  "TT",
  "VI",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
  "YT",
];
const countryList = [
  "United States of America",
  "Canada",
  "United Kingdom",
  "Australia",
  "Austria",
  "Belgium",
  "Brazil",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Latvia",
  "Lituania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "New Zealand",
  "Poland",
  "Portugal",
  "Romania",
  "Russian Federation",
  "Slovakia",
  "Slovenia",
  "South Africa",
  "Spain",
  "Sweden",
  "Switzerland",
  "Thailand",
  "United Arab Emirates (the)",
];
const months = ref();
const years = ref();
const lineItems = ref(Array<lineItemInterface>());
const errors = ref("");
const paymentOptions = ref([
  { text: "Credit Card", value: "credit_card" },
  { text: "Ach", value: "ach" },
  { text: "Check", value: "check" },
]);
const accountType = ref();
const cardTypes = ref();
const chosenSavedCard = ref({});

const router = useRouter();
const route = useRoute();
async function getFacility() {
  errors.value = "";
  const response = await api({
    url: `facility/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    facility.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

watch(paymentAmount, () => {
  if (paymentAmount.value) {
    convenienceFeeAmount.value = (paymentAmount.value / 100) * 4;
  }
});

watch(paymentMethod, () => {
  if (["credit_card", "ach"].includes(paymentMethod.value)) {
    if (!formFields.value.transaction.payment_account.first_name) {
      formFields.value.transaction.payment_account.first_name =
        customer.value.name.split(" ")[0];
    }
    if (!formFields.value.transaction.payment_account.last_name) {
      formFields.value.transaction.payment_account.last_name =
        customer.value.name.split(" ")[1];
    }
    if (!formFields.value.transaction.payment_account.address) {
      formFields.value.transaction.payment_account.address =
        customer.value.address;
    }

    if (!formFields.value.transaction.payment_account.city) {
      formFields.value.transaction.payment_account.city = customer.value.city;
    }
    if (!formFields.value.transaction.payment_account.state) {
      formFields.value.transaction.payment_account.state = customer.value.state;
    }
    if (!formFields.value.transaction.payment_account.zip) {
      formFields.value.transaction.payment_account.zip = customer.value.zip;
    }
    if (!formFields.value.transaction.payment_account.country) {
      formFields.value.transaction.payment_account.country =
        customer.value.country;
    }
  }
});
onMounted(async () => {
  await getFacility();

  await getCustomer();
  await getLineItems();
  await getPaymentAccounts();
  moment.locale("en"); // sets words language (optional if current locale is to be used)
  months.value = moment.months(); // returns a list of months in the current locale (January, February, etc.)
  let current_year = moment().year();
  let end_year = Number(current_year) + 20;
  let year_list = [];
  for (let i = Number(current_year); i <= end_year; i++) {
    year_list.push(i);
  }
  years.value = year_list;
  cardTypes.value = facility.value.enabled_credit_card_types;
  if (achNotAccepted) {
    paymentOptions.value = [
      { text: "Credit Card", value: "credit_card" },
      { text: "Check", value: "check" },
    ];
  }
  status.value = "completed";
});
async function getCheckBatches() {
  errors.value = "";
  const response = await api({
    url: `check_batches/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    checkBatches.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getCheckBatches();
async function updateSelectedItems(item: lineItemInterface) {
  if (!item.pay) {
    selectedItems.value.push({ id: Number(item.id), amount: item.total });
    paymentAmount.value += Number(item.total);
  } else {
    let index = selectedItems.value.findIndex(function (
      selected: selectedItemInterface
    ) {
      return selected.id === Number(item.id);
    });
    if (index != -1) {
      selectedItems.value.splice(index, 1);
      paymentAmount.value -= Number(item.total);
    }
  }
  paymentAmount.value = Number(paymentAmount.value.toFixed(2));
}
async function createPayment() {
  const json = JSON.parse(
    JSON.stringify(formFields.value.transaction.payment_account)
  );
  let url = `payment_accounts/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    responseModal.value = true;
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function getConvenienceFeeToken() {
  let method;
  let payment_information;
  if (Object.keys(chosenSavedCard.value).length) {
    method = null;
  } else if (paymentMethod.value == "credit_card") {
    method = formFields.value.transaction.payment_account;
    let card_exp = method.card_expires_on.split("-");
    if (card_exp[1].length == 1) {
      card_exp[1] = "0" + card_exp[1];
    }
    let country = method.country;
    if (country.includes("United States")) {
      country = "US";
    } else if (country.includes("Canada")) {
      country = "CA";
    }

    payment_information = {
      card: {
        name: customer.value.name,
        number: method.card_number,
        expMonth: card_exp[1],
        address: {
          postalCode: method.zip,
          country: country,
          region: method.state,
          streetAddress: method.address,
          city: method.city,
        },
        expYear: card_exp[0],
        cvc: method.verification_value,
      },
    };
  } else if (paymentMethod.value == "ach") {
    method = formFields.value.transaction.payment_account;
    let phone = "";
    if (customer.value.phone) {
      phone = customer.value.phone.substring(2);
    } else if (customer.value.cell_phone) {
      phone = customer.value.cell_phone.substring(2);
    }
    payment_information = {
      bankAccount: {
        name: customer.value.name,
        accountNumber:
          formFields.value.transaction.payment_account.account_number,
        accountType: accountType.value,
        phone: phone,
        routingNumber:
          formFields.value.transaction.payment_account.routing_number,
      },
    };
  }
  if (method) {
    const json = JSON.parse(JSON.stringify(payment_information));
    let url = `generate_token_convenience_fee/?facilityId=${props.facilityId}&id=${props.customerId}`;
    const responseData = await api({
      url,
      method: "POST",
      json,
    });
    if ([200, 201].includes(responseData.status)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      tokenFee.value = responseData.body.value;
    }
  }
}

async function convenienceFee() {
  await getConvenienceFeeToken();
  const json = JSON.parse(
    JSON.stringify({
      token: tokenFee.value,
      chosen_saved_payment: chosenSavedCard.value,
      payment_method: paymentMethod.value,
      save_payment: savePayment.value,
      total_amount: convenienceFeeAmount.value.toFixed(2),
      tenant: {
        name: customer.value.name,
        id: props.customerId,
      },
    })
  );

  let url = `convenience_fee/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    console.log("successful convenience fee");
  } else if (responseData.status == 409) {
    if (
      responseData.body.errors &&
      responseData.body.errors[0].message.includes("Card already exists.")
    ) {
      await quickBooksAuthCheck();
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function quickBooksAuthCheck() {
  let url = `auth_check/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "GET",
  });
  if ([200, 201].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.url) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      urlForAuth.value = responseData.body.url;
    } else {
      await convenienceFee();
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function submitForm() {
  formSubmitting.value = true;
  successfulPayment.value = false;

  formFields.value.transaction.amount = paymentAmount.value.toString();
  formFields.value.transaction.line_item_id = selectedItems.value.map(
    (item) => item.id
  );
  if (["credit_card"].includes(paymentMethod.value)) {
    formFields.value.transaction.payment_account.card_expires_on =
      expirationYear.value + "-" + expirationMonth.value + "-01";
  }

  if (["ach", "check", "credit_card"].includes(paymentMethod.value)) {
    if (paymentMethod.value == "credit_card") {
      formFields.value.transaction.payment_method = "one_time_card";
    } else if (paymentMethod.value == "ach") {
      formFields.value.transaction.payment_method = "one_time_ach";
    } else {
      formFields.value.transaction.payment_method = paymentMethod.value;
    }
    formFields.value.transaction.payment_account.kind = paymentMethod.value;
  } else {
    formFields.value.transaction.payment_account_id = paymentMethod.value;
    let method = paymentAccounts.value.filter(
      (item) => item.id == paymentMethod.value
    )[0];
    chosenSavedCard.value = method;
    formFields.value.transaction.payment_method = method.kind;
  }
  const json = JSON.parse(JSON.stringify(formFields.value));
  formErrors.value = {};
  let url = `transactions/?id=${props.customerId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    if (convenienceFeeSetting && paymentMethod.value != "check") {
      await quickBooksAuthCheck();
    }
    successfulPayment.value = true;
    if (savePayment.value) {
      createPayment();
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
  responseModal.value = true;

  formSubmitting.value = false;
}
async function modalClosed() {
  if (successfulPayment.value) {
    router.push(
      typeof route.query.next === "string"
        ? route.query.next
        : {
            name: "customer_detail_ess",
            params: {
              id: props.customerId,
              facilityId: props.facilityId,
            },
          }
    );
  }
  responseModal.value = false;
  errorPaymentMessage.value = "";
}
async function getLineItems() {
  errors.value = "";
  const response = await api({
    url: `line_items/?id=${props.customerId}&facilityId=${props.facilityId}&all_items=true`,
  });
  if (response.status == 200) {
    lineItems.value = response.body;
    let amount = 0;
    for (let item of lineItems.value) {
      item.pay = true;
      item.total = (
        Number(item.tax) +
        Number(item.amount) -
        (Number(item.amount_paid) + Number(item.tax_paid))
      ).toFixed(2);
      subtotal.value += Number(item.total);
      selectedItems.value.push({ id: Number(item.id), amount: item.total });
      amount += Number(item.total);
    }
    credit.value = Number(customer.value.credit);
    if (credit.value < subtotal.value) {
      amountDue.value = Number(subtotal.value - credit.value);
    } else {
      amountDue.value = 0;
    }
    paymentAmount.value = Number(amount.toFixed(2));
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getPaymentAccounts() {
  errors.value = "";
  const response = await api({
    url: `payment_accounts/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    paymentAccounts.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("h1", null, "Make a Payment for " + _toDisplayString(__props.customerName), 1),
    _createVNode(OutstandingFeeBanner, {
      "facility-id": __props.facilityId,
      "customer-id": __props.customerId,
      onTotal: _cache[0] || (_cache[0] = ($event: any) => (missedFeeAmount.value = $event))
    }, null, 8, ["facility-id", "customer-id"]),
    _hoisted_1,
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : (_openBlock(), _createElementBlock("fieldset", _hoisted_2, [
          (lineItems.value && lineItems.value.length)
            ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                _createElementVNode("tr", null, [
                  (!proceedToPayment.value)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_4, _hoisted_6))
                    : _createCommentVNode("", true),
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lineItems.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id + 'item'
                  }, [
                    (!proceedToPayment.value)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": ($event: any) => ((item.pay) = $event),
                            type: "checkbox",
                            onClick: ($event: any) => (updateSelectedItems(item))
                          }, null, 8, _hoisted_15), [
                            [_vModelCheckbox, item.pay]
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", null, _toDisplayString(_unref(moment)(item.created_at).format("M/DD/YYYY, h:mm A")), 1),
                    _createElementVNode("td", null, _toDisplayString(_unref(moment)(item.due_on).format("M/DD/YYYY")), 1),
                    _createElementVNode("td", null, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, [
                      _createTextVNode(_toDisplayString(item.description) + " ", 1),
                      (item.billable_type)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(item.billable_type), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString((Number(item.amount) - Number(item.amount_paid)).toFixed(2)), 1),
                    _createElementVNode("td", null, _toDisplayString((Number(item.tax) - Number(item.tax_paid)).toFixed(2)), 1),
                    _createElementVNode("td", null, _toDisplayString(item.total), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_RouterLink, {
                        to: {
              name: 'line_item',
              params: {
                customerId: __props.customerId,
                lineItemId: item.id,
                customerName: __props.customerName,
                facilityId: __props.facilityId,
              },
            }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_16
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_17, "No items")),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("p", null, "Subtotal $" + _toDisplayString(subtotal.value.toFixed(2)), 1),
            _hoisted_19,
            _createElementVNode("p", null, "Credit $" + _toDisplayString(credit.value.toFixed(2)), 1),
            _hoisted_20,
            _createElementVNode("p", null, "Amount Due $" + _toDisplayString(amountDue.value.toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentAmount).value = $event)),
                type: "decimal",
                disabled: proceedToPayment.value
              }, null, 8, _hoisted_25), [
                [_vModelText, paymentAmount.value]
              ])
            ]),
            (_unref(convenienceFeeSetting))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("input", {
                      value: (convenienceFeeAmount.value + missedFeeAmount.value).toFixed(2),
                      type: "decimal",
                      disabled: ""
                    }, null, 8, _hoisted_29)
                  ]),
                  (missedFeeAmount.value > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_30, " Includes $" + _toDisplayString(Number(convenienceFeeAmount.value).toFixed(2)) + " current fee + $" + _toDisplayString(Number(missedFeeAmount.value).toFixed(2)) + " previously missed fee. ", 1))
                    : _createCommentVNode("", true),
                  _hoisted_31,
                  (paymentAmount.value && convenienceFeeAmount.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("input", {
                          value: 
              (
                Number(paymentAmount.value) +
                Number(convenienceFeeAmount.value) +
                Number(missedFeeAmount.value)
              ).toFixed(2)
            ,
                          type: "decimal",
                          disabled: ""
                        }, null, 8, _hoisted_34)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (!proceedToPayment.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn",
                disabled: paymentAmount.value <= 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (proceedToPayment.value = true))
              }, " Proceed to Payment Summary ", 8, _hoisted_35))
            : _createCommentVNode("", true),
          (proceedToPayment.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 3,
                onSubmit: _withModifiers(submitForm, ["prevent"])
              }, [
                _hoisted_37,
                (paymentAccounts.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((paymentMethod).value = $event)),
                        class: "form-select",
                        required: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentAccounts.value, (account) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: account.id + 'account',
                            value: account.id
                          }, _toDisplayString(account.account_summary), 9, _hoisted_39))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentOptions.value, (method) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: method.value + 'payment',
                            value: method.value
                          }, _toDisplayString(method.text), 9, _hoisted_40))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, paymentMethod.value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (['ach', 'credit_card'].includes(paymentMethod.value))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formFields.value.transaction.payment_account.first_name) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.transaction.payment_account.first_name]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.transaction.payment_account.last_name) = $event)),
                          type: "text",
                          required: ""
                        }, null, 512), [
                          [_vModelText, formFields.value.transaction.payment_account.last_name]
                        ])
                      ]),
                      (paymentMethod.value == 'ach')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_46, [
                              _hoisted_47,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formFields.value.transaction.payment_account.account_number) = $event)),
                                type: "text",
                                required: ""
                              }, null, 512), [
                                [_vModelText, formFields.value.transaction.payment_account.account_number]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _hoisted_49,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((
                formFields.value.transaction.payment_account
                  .account_number_confirmation
              ) = $event)),
                                type: "text",
                                required: ""
                              }, null, 512), [
                                [_vModelText, 
                formFields.value.transaction.payment_account
                  .account_number_confirmation
              ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                              _hoisted_51,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formFields.value.transaction.payment_account.routing_number) = $event)),
                                type: "text",
                                required: ""
                              }, null, 512), [
                                [_vModelText, formFields.value.transaction.payment_account.routing_number]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                              _hoisted_53,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((accountType).value = $event)),
                                class: "form-select",
                                required: ""
                              }, _hoisted_58, 512), [
                                [_vModelSelect, accountType.value]
                              ])
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      (['credit_card'].includes(paymentMethod.value))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_59, [
                              _hoisted_60,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formFields.value.transaction.payment_account.card_type) = $event)),
                                class: "form-select",
                                required: ""
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cardTypes.value, (card) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: card + 'card',
                                    value: card
                                  }, _toDisplayString(card), 9, _hoisted_61))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, formFields.value.transaction.payment_account.card_type]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _hoisted_63,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.transaction.payment_account.card_number) = $event)),
                                type: "text",
                                required: ""
                              }, null, 512), [
                                [_vModelText, formFields.value.transaction.payment_account.card_number]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _hoisted_65,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((expirationMonth).value = $event)),
                                class: "form-select",
                                required: ""
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: month,
                                    value: index + 1
                                  }, _toDisplayString(index + 1) + " - " + _toDisplayString(month), 9, _hoisted_66))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, expirationMonth.value]
                              ]),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((expirationYear).value = $event)),
                                class: "form-select",
                                required: ""
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: year + 'year',
                                    value: year
                                  }, _toDisplayString(year), 9, _hoisted_67))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, expirationYear.value]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_68, [
                              _hoisted_69,
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((
                formFields.value.transaction.payment_account.verification_value
              ) = $event)),
                                type: "text"
                              }, null, 512), [
                                [_vModelText, 
                formFields.value.transaction.payment_account.verification_value
              ]
                              ])
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_70, [
                        _hoisted_71,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formFields.value.transaction.payment_account.address) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.transaction.payment_account.address]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _hoisted_73,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formFields.value.transaction.payment_account.city) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.transaction.payment_account.city]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _hoisted_75,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formFields.value.transaction.payment_account.state) = $event)),
                          class: "form-select"
                        }, [
                          _hoisted_76,
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(states, (state) => {
                            return _createElementVNode("option", { key: state }, _toDisplayString(state), 1)
                          }), 64))
                        ], 512), [
                          [_vModelSelect, formFields.value.transaction.payment_account.state]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_77,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formFields.value.transaction.payment_account.zip) = $event)),
                          type: "text"
                        }, null, 512), [
                          [_vModelText, formFields.value.transaction.payment_account.zip]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _hoisted_78,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formFields.value.transaction.payment_account.country) = $event)),
                          class: "form-select",
                          required: ""
                        }, [
                          _hoisted_79,
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(countryList, (country) => {
                            return _createElementVNode("option", { key: country }, _toDisplayString(country), 1)
                          }), 64))
                        ], 512), [
                          [_vModelSelect, formFields.value.transaction.payment_account.country]
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((savePayment).value = $event)),
                          type: "checkbox",
                          class: "form-check-input"
                        }, null, 512), [
                          [_vModelCheckbox, savePayment.value]
                        ]),
                        _hoisted_80,
                        _hoisted_81,
                        _hoisted_82
                      ])
                    ]))
                  : (paymentMethod.value == 'check')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                        _createElementVNode("div", _hoisted_84, [
                          _hoisted_85,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formFields.value.transaction.check_number) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, formFields.value.transaction.check_number]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_86, [
                          _hoisted_87,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formFields.value.transaction.check_batch_id) = $event)),
                            class: "form-select"
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkBatches.value, (batch) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: batch.id + 'batch',
                                value: batch.id
                              }, _toDisplayString(batch.name), 9, _hoisted_88))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, formFields.value.transaction.check_batch_id]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_89, [
                          _hoisted_90,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formFields.value.transaction.message) = $event)),
                            type: "text"
                          }, null, 512), [
                            [_vModelText, formFields.value.transaction.message]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                _hoisted_91,
                (formSubmitting.value)
                  ? (_openBlock(), _createBlock(BaseSpinner, {
                      key: 3,
                      preset: "large"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  class: "btn",
                  onClick: _cache[24] || (_cache[24] = ($event: any) => (proceedToPayment.value = false))
                }, " Adjust Payment Amount ")
              ], 40, _hoisted_36))
            : _createCommentVNode("", true),
          (formErrors.value.errors)
            ? (_openBlock(), _createBlock(_component_BaseAlert, {
                key: 4,
                variant: "danger",
                class: "js-form-error",
                dismissible: "",
                onDismissed: _cache[25] || (_cache[25] = ($event: any) => (formErrors.value = {}))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(formErrors.value.errors), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])),
    (responseModal.value)
      ? (_openBlock(), _createBlock(PaymentResponse, {
          key: 2,
          error: errorPaymentMessage.value,
          success: successfulPayment.value,
          onModalClosed: modalClosed
        }, null, 8, ["error", "success"]))
      : _createCommentVNode("", true),
    (urlForAuth.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          href: urlForAuth.value,
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Regenerate Quickbooks connection", 8, _hoisted_92))
      : _createCommentVNode("", true)
  ], 64))
}
}

})